import {
	defAction
}from "../../../helpers/defaultAction"
import api from './api'
import {
	reOrgConstructionMaterialPricePeriodChangeConstants
}from "./constants"
import downloadFile from "../../../helpers/downloadFile"

export const reOrgConstructionMaterialPricePeriodChangeActions = {
	getPaged,
	getListPeriodRegionReOrg,
	getExampleFile,
	getNotInputMaterials,
	getByFile,
	create,
	update,
	remove,
	clear,
	getHistoryPaged,
	getPricesByPeriodsPaged,
	getFileReOrgMaterialPricesByPeriods,
	getMaterialPricesByPeriods,
	getFile,
	getOrgExampleFile,
	submitReOrgPricesForPeriod,
	getOrgNotInputMaterials,
	deleteSelectedPrices,
	deleteFilteredPrices
}

function getHistoryPaged(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetHistoryPaged,
		service   : {
			func   : api.getHistoryPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPricesByPeriodsPaged(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetPricesByPeriodsPaged,
		service   : {
			func   : api.getPricesByPeriodsPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getListPeriodRegionReOrg(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetListPeriodRegionReOrg,
		service   : {
			func   : api.getListPeriodRegionReOrg,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getExampleFile(){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetExampleFile,
		service   : {
			func: api.getExampleFile
		},
		sucFunction: (res) => downloadFile(res, "Шаблон.xlsx")
	}
	return defAction(dispatchObj)
}

function getNotInputMaterials(params){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetExampleFile,
		service   : {
			func   : api.getNotInputMaterials,
			params : params
		},
		sucFunction: (res) => downloadFile(res, "Материалы без поданных сведений.xlsx")
	}
	return defAction(dispatchObj)
}

function getByFile(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetByFile,
		service   : {
			func   : api.getByFile,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteSelectedPrices(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.DeleteSelectedPrices,
		service   : {
			func   : api.deleteSelectedPrices,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteFilteredPrices(values){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.DeleteFilteredPrices,
		service   : {
			func   : api.deleteFilteredPrices,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getFileReOrgMaterialPricesByPeriods(params){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetExampleFile,
		service   : {
			func   : api.getFileReOrgMaterialPricesByPeriods,
			params : params
		},
		sucFunction: (res) => downloadFile(res, "Сведения о ценах.xlsx")
	}
	return defAction(dispatchObj)
}

function getMaterialPricesByPeriods(params){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetMaterialPricesByPeriods,
		service   : {
			func   : api.getMaterialPricesByPeriods,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getFile(params){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetExampleFile,
		service   : {
			func   : api.getFile,
			params : params
		},
		sucFunction: (res) => downloadFile(res, "Ценовые предложения организаций.xlsx")
	}
	return defAction(dispatchObj)
}

function getOrgExampleFile(params){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetOrgExampleFile,
		service   : {
			func   : api.getOrgExampleFile,
			params : params
		},
		sucFunction: (res) => downloadFile(res, "Шаблон организаций.xlsx")
	}
	return defAction(dispatchObj)
}

function submitReOrgPricesForPeriod(params){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.SubmitReOrgPricesForPeriod,
		service   : {
			func   : api.submitReOrgPricesForPeriod,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getOrgNotInputMaterials(params){
	const dispatchObj = {
		constants : reOrgConstructionMaterialPricePeriodChangeConstants.GetOrgNotInputMaterials,
		service   : {
			func   : api.getOrgNotInputMaterials,
			params : params
		},
		sucFunction: (res) => downloadFile(res, "Материалы организаций без поданных сведений.xlsx")
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reOrgConstructionMaterialPricePeriodChangeConstants.CLEAR
	})
}